import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Spinner } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaClock, FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaPaperPlane, FaCheck } from 'react-icons/fa';
import { PostToApi } from '../utils/api';
import '../styles/Pages.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await PostToApi('/contacts', formData);
      if (response.success) {
        setSubmitted(true);
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
        setTimeout(() => setSubmitted(false), 5000);
      }
    } catch (error) {
      console.error('Error submitting contact form:', error);
      alert('Error submitting message: ' + error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactInfo = [
    { icon: FaMapMarkerAlt, title: 'Office Address', details: ['110, Auto Market Rd, Auto Market,', 'Shastri Nagar, Hisar, Haryana 125001'], color: '#3B82F6' },
    { icon: FaPhone, title: 'Phone Number', details: ['+91 98765 43210', '+91 12345 67890'], color: '#22C55E' },
    { icon: FaEnvelope, title: 'Email Address', details: ['support@gpstracking.com', 'sales@gpstracking.com'], color: '#F59E0B' },
    { icon: FaClock, title: 'Business Hours', details: ['Monday - Saturday: 9:00 AM - 7:00 PM', 'Sunday: Closed'], color: '#A855F7' }
  ];

  const socialLinks = [
    { icon: FaFacebook, url: '#', color: '#1877F2' },
    { icon: FaTwitter, url: '#', color: '#1DA1F2' },
    { icon: FaLinkedin, url: '#', color: '#0A66C2' },
    { icon: FaInstagram, url: '#', color: '#E4405F' }
  ];

  const faqs = [
    { question: 'How do I install the GPS device?', answer: 'Our technicians provide free installation. Contact support to schedule an appointment.' },
    { question: 'What is the subscription cost?', answer: 'We offer flexible plans starting from ₹299/month per vehicle. Contact sales for custom quotes.' },
    { question: 'Can I track multiple vehicles?', answer: 'Yes, you can track unlimited vehicles with our enterprise plans.' },
    { question: 'Is there a mobile app available?', answer: 'Yes, our mobile app is available on both iOS and Android platforms.' }
  ];

  return (
    <Container fluid className="p-3">
      <div className="page-header"><h4 className="page-title">Contact Us</h4></div>
      <Row>
        <Col lg={7} className="mb-4">
          <Card className="page-card h-100">
            <Card.Header className="bg-white border-bottom"><h6 className="mb-0 fw-semibold text-dark">Send us a Message</h6></Card.Header>
            <Card.Body>
              {submitted ? (
                <div className="text-center py-5">
                  <div className="mx-auto mb-4 d-flex align-items-center justify-content-center" style={{ width: 80, height: 80, borderRadius: '50%', backgroundColor: 'rgba(34, 197, 94, 0.1)' }}><FaCheck size={40} color="#22C55E" /></div>
                  <h5 className="mb-2">Message Sent Successfully!</h5>
                  <p className="text-muted">We'll get back to you within 24 hours.</p>
                </div>
              ) : (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}><Form.Group className="mb-3"><Form.Label className="form-label-custom">Full Name</Form.Label><Form.Control type="text" className="form-control-custom" placeholder="Enter your name" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required /></Form.Group></Col>
                    <Col md={6}><Form.Group className="mb-3"><Form.Label className="form-label-custom">Email Address</Form.Label><Form.Control type="email" className="form-control-custom" placeholder="Enter your email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} required /></Form.Group></Col>
                  </Row>
                  <Row>
                    <Col md={6}><Form.Group className="mb-3"><Form.Label className="form-label-custom">Phone Number</Form.Label><Form.Control type="tel" className="form-control-custom" placeholder="Enter your phone" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} /></Form.Group></Col>
                    <Col md={6}><Form.Group className="mb-3"><Form.Label className="form-label-custom">Subject</Form.Label>
                      <Form.Select className="form-control-custom" value={formData.subject} onChange={(e) => setFormData({...formData, subject: e.target.value})} required>
                        <option value="">Select a subject</option>
                        <option value="general">General Inquiry</option><option value="sales">Sales Query</option><option value="support">Technical Support</option><option value="billing">Billing Issue</option><option value="feedback">Feedback</option>
                      </Form.Select>
                    </Form.Group></Col>
                  </Row>
                  <Form.Group className="mb-4"><Form.Label className="form-label-custom">Message</Form.Label><Form.Control as="textarea" rows={5} className="form-control-custom" placeholder="Write your message here..." value={formData.message} onChange={(e) => setFormData({...formData, message: e.target.value})} required /></Form.Group>
                  <Button variant="primary" type="submit" className="px-4" style={{ borderRadius: '8px' }} disabled={isSubmitting}>
                    {isSubmitting ? <>Sending...</> : <><FaPaperPlane className="me-2" /> Send Message</>}
                  </Button>
                </Form>
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col lg={5} className="mb-4">
          <Card className="page-card mb-4">
            <Card.Header className="bg-white border-bottom"><h6 className="mb-0 fw-semibold text-dark">Contact Information</h6></Card.Header>
            <Card.Body>
              {contactInfo.map((info, index) => {
                const IconComponent = info.icon;
                return (
                  <div key={index} className="contact-info-item">
                    <div className="contact-icon-box" style={{ background: `linear-gradient(135deg, ${info.color} 0%, ${info.color}CC 100%)` }}><IconComponent /></div>
                    <div><h6 className="mb-1 fw-semibold">{info.title}</h6>{info.details.map((detail, i) => <p key={i} className="mb-0 text-muted small">{detail}</p>)}</div>
                  </div>
                );
              })}
              <div className="mt-4 pt-3 border-top">
                <h6 className="mb-3 fw-semibold">Follow Us</h6>
                <div className="d-flex gap-2">
                  {socialLinks.map((social, index) => {
                    const IconComponent = social.icon;
                    return (
                      <a key={index} href={social.url} className="d-flex align-items-center justify-content-center" style={{ width: 40, height: 40, borderRadius: 10, backgroundColor: `${social.color}15`, color: social.color }}><IconComponent /></a>
                    );
                  })}
                </div>
              </div>
            </Card.Body>
          </Card>
          <Card className="page-card">
            <Card.Header className="bg-white border-bottom"><h6 className="mb-0 fw-semibold text-dark">Frequently Asked Questions</h6></Card.Header>
            <Card.Body>
              {faqs.map((faq, index) => (
                <div key={index} className={`pb-3 ${index < faqs.length - 1 ? 'mb-3 border-bottom' : ''}`}>
                  <h6 className="fw-semibold mb-2" style={{ fontSize: '0.9rem' }}>{faq.question}</h6>
                  <p className="text-muted small mb-0">{faq.answer}</p>
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Card className="page-card">
        <Card.Header className="bg-white border-bottom"><h6 className="mb-0 fw-semibold text-dark">Our Location</h6></Card.Header>
        <Card.Body className="p-0">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3463.2245678901234!2d75.71234567890123!3d29.15678901234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjnCsDA5JzI0LjQiTiA3NcKwNDInNDQuNCJF!5e0!3m2!1sen!2sin!4v1234567890123"
            width="100%" height="300" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Office Location" />
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ContactUs;
